import { EmailVerificationService as OvermapEmailVerificationService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class EmailVerificationService extends OvermapEmailVerificationService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
